import ChipBusinessTripFormStatus from '@/components/chip/ChipBusinessTripFormStatus';
import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columnName = {
    code: 'code',
    customerName: 'customer.name',
    technicianName: 'technical.fullname',
    checkinPlan: 'checkinPlan',
    checkoutPlan: 'checkoutPlan',
    status: 'status',
};

export const columns = (columnParams: any): TableColumnConfig[] => {
    return [
        {
            field: columnName.code,
            headerName: 'Mã phiếu',
            editable: false,
            sortable: true,
            minWidth: 150,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            renderCell: params => <HoverCopyCell value={params.value} />,
        },
        {
            field: columnName.customerName,
            headerName: 'Tên khách hàng',
            editable: false,
            sortable: true,
            minWidth: 300,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            renderCell: params => (
                <HoverCopyCell value={params.row.customer?.name}>
                    <EntityDetailButton
                        text={params.row.customer?.name}
                        identifier={columnParams?.identifier}
                        entityId={params.row.customerId}
                        type='CUSTOMER'
                    />
                </HoverCopyCell>
            ),
            excludeRoles: [RoleEnum.CUSTOMER],
        },
        {
            field: columnName.technicianName,
            headerName: 'Người phụ trách',
            editable: false,
            sortable: true,
            minWidth: 200,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            renderCell: params => (
                <HoverCopyCell value={params.row.technical?.fullname}>
                    <EntityDetailButton
                        text={params.row.technical?.fullname}
                        identifier={columnParams?.identifier}
                        entityId={params.row.technicalId}
                        type='ASSIGNEE'
                    />
                </HoverCopyCell>
            ),
            excludeRoles: [RoleEnum.KTV],
        },
        {
            field: columnName.checkinPlan,
            headerName: 'Check-in (dự kiến)',
            editable: false,
            sortable: true,
            minWidth: 200,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            renderCell: params => (
                <HoverCopyCell
                    value={dateUtils.getDateTimeLocal(params.row.checkinPlan)}
                />
            ),
        },
        {
            field: columnName.checkoutPlan,
            headerName: 'Check-out (dự kiến)',
            editable: false,
            sortable: true,
            minWidth: 200,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            renderCell: params => (
                <HoverCopyCell
                    value={dateUtils.getDateTimeLocal(params.row.checkoutPlan)}
                />
            ),
        },
        {
            field: columnName.status,
            headerName: 'Trạng thái công tác',
            editable: false,
            sortable: true,
            minWidth: 200,
            flex: 1,
            sortingOrder: ['asc', 'desc'],
            renderCell: params => (
                <ChipBusinessTripFormStatus
                    status={params.row.status}
                    size='small'
                />
            ),
        },
    ];
};
